import { createFileRoute } from '@tanstack/react-router';
import { SigningRequestDetail } from '@features/signing-requests/SigningRequestDetail';

export const Route = createFileRoute('/w/signing-requests/$requestId')({
  staticData: {
    hideShell: true,
    breadcrumb: 'Signing Request Detail',
    breadcrumbKey: 'K_BREADCRUMB_SIGNING_REQUEST_DETAIL',
  },
  component: WorkpaySigningRequestDetailPage,
});

function WorkpaySigningRequestDetailPage() {
  const { requestId } = Route.useParams();
  return <SigningRequestDetail requestId={requestId} routeTo="/w/signing-requests" />;
}
